export const hasOverviewShape = value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  return (
    typeof value.review_snippet === 'string'
    || (value.score_assessment != null && typeof value.score_assessment === 'object')
    || Array.isArray(value.whats_working)
    || Array.isArray(value.areas_of_improvement)
    || Array.isArray(value.primary_metrics)
    || typeof value.primary_audience === 'string'
  );
};

export const parseOverviewData = raw => {
  if (hasOverviewShape(raw)) {
    return raw;
  }

  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim();

  if (!trimmed.startsWith('{') || !trimmed.endsWith('}')) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed);

    return hasOverviewShape(parsed) ? parsed : null;
  }
  catch {
    return null;
  }
};

export const mapChatMessage = msg => {
  const isOverviewSource = msg.metadata?.source === 'overview';
  const parsedOverview = parseOverviewData(msg.content);
  const overview = isOverviewSource ? (parsedOverview || {}) : parsedOverview;

  return {
    id: msg.uuid,
    role: msg.role,
    content: msg.content,
    sequence: msg.sequence,
    created_at: msg.created_at,
    ...(overview
      ? { type: 'overview_report', overview }
      : {}),
  };
};
